import type { EdicaoAdmin } from "../../../services/admin";

/**
 * Espelha a regra do back (`isFreeEdition`): a edição só é PAGA quando está à
 * venda e tem preço. Fora de venda, preço zero ou "liberada grátis" → gratuita,
 * mesmo que tenha um valor cadastrado. À venda com preço desconhecido conta como paga.
 */
export const isEdicaoFree = (
  e: Pick<EdicaoAdmin, "aVenda" | "liberadaGratis" | "valorAVista">,
): boolean => {
  if (e.liberadaGratis === true || e.aVenda !== true) return true;
  return e.valorAVista != null && Number(e.valorAVista) <= 0;
};

// `valorAVista` trafega em CENTAVOS (convenção da API).
const fmtCentavos = (cents: number): string =>
  `R$ ${(cents / 100).toFixed(2).replace(".", ",")}`;

export interface AccessTagView {
  label: string;
  color: "blue" | "green" | "default";
}

/**
 * Etiqueta de acesso da coleção: "Paga · R$ 10,90", "Gratuita" ou, quando a
 * gratuita ainda tem um valor cadastrado (fora de venda), "Gratuita · R$ 10,90" em cinza.
 */
export const accessTag = (
  free: boolean,
  priceCents: number | null,
): AccessTagView => {
  const priced = priceCents != null && priceCents > 0;
  if (!free)
    return {
      label: priced ? `Paga · ${fmtCentavos(priceCents)}` : "Paga",
      color: "blue",
    };
  return priced
    ? { label: `Gratuita · ${fmtCentavos(priceCents)}`, color: "default" }
    : { label: "Gratuita", color: "green" };
};

export const priceCentsOf = (
  e: Pick<EdicaoAdmin, "valorAVista">,
): number | null => (e.valorAVista == null ? null : Number(e.valorAVista));
